import { connect } from 'react-redux';
import { withLastLocation } from 'react-router-dom-last-location';
import SearchResults from './search_results';
import withPGTranslation  from '../../config/withPGTranslation';
import { getRouteSettings } from '../../config/util';

const mapStateProps = ({
  user
}, ownProps) => {
  const { currentPath: { routeKey } } = ownProps;
  return {
    routeSettings: getRouteSettings({ routeKey }),
    userId: user?.user?.id
  };
};

export default connect(mapStateProps)(withLastLocation(withPGTranslation(SearchResults)));
